<template>
  <b-container fluid class="container mb-sm-5">
    <div class="compound-wrapper">
      <b-row class="compound-info">
        <b-col cols="2">
          <p class="info-title numero">Número do Composto</p>
          <b-row no-gutters>
            <b-col cols="3" class="icon">
              <svg
                width="27"
                height="23"
                viewBox="0 0 27 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.66989 3.38609C4.89632 3.49954 5.15817 3.5198 5.39936 3.44254C5.64055 3.36528 5.84189 3.19665 5.96026 2.97275L5.96285 2.96759C6.04856 2.84057 6.15309 2.72734 6.27285 2.63175C6.51826 2.43542 6.95226 2.19775 7.68593 2.19775C8.32143 2.19775 8.69343 2.50388 8.8381 2.79192C8.97114 3.0593 8.97114 3.41709 8.61593 3.77359C8.36406 4.02417 8.03985 4.24246 7.62651 4.48142C7.50222 4.55303 7.37736 4.62365 7.25193 4.69325C6.94193 4.86763 6.5906 5.06396 6.27931 5.26805C5.30151 5.90613 4.34956 6.83225 4.1416 8.53855C4.12496 8.67462 4.1374 8.81268 4.17809 8.94359C4.21877 9.07451 4.28678 9.1953 4.37762 9.29797C4.46845 9.40065 4.58004 9.48288 4.70502 9.53923C4.83 9.59557 4.96551 9.62475 5.1026 9.62484H9.94635C10.2033 9.62484 10.4497 9.52277 10.6314 9.3411C10.813 9.15942 10.9151 8.91302 10.9151 8.65609C10.9151 8.39916 10.813 8.15275 10.6314 7.97108C10.4497 7.7894 10.2033 7.68734 9.94635 7.68734H6.45626C6.67585 7.37346 6.97551 7.12675 7.33847 6.88909C7.59551 6.72117 7.84481 6.58296 8.12251 6.42667C8.27106 6.344 8.42864 6.25617 8.59914 6.158C9.04993 5.8958 9.55239 5.57675 9.9851 5.14275C10.9216 4.20759 11.083 2.9508 10.5702 1.9265C10.0691 0.922879 8.98793 0.260254 7.68593 0.260254C6.4821 0.260254 5.62572 0.668421 5.06385 1.11792C4.76617 1.35568 4.50996 1.64113 4.30564 1.96267C4.29045 1.98819 4.27581 2.01403 4.26172 2.04017L4.24622 2.066L4.24106 2.07892L4.23847 2.0828V2.08538L4.23589 2.08796C4.12114 2.31783 4.10239 2.58387 4.18378 2.82755C4.26517 3.07124 4.44003 3.27261 4.66989 3.38738V3.38609ZM16.5661 3.79167C16.3918 3.95442 16.0495 4.13525 15.4359 4.13525C15.179 4.13525 14.9326 4.23732 14.7509 4.41899C14.5692 4.60067 14.4672 4.84708 14.4672 5.104C14.4672 5.36093 14.5692 5.60734 14.7509 5.78901C14.9326 5.97069 15.179 6.07275 15.4359 6.07275C16.0482 6.07275 16.3918 6.25359 16.5661 6.41634C16.7405 6.57909 16.8116 6.78188 16.7986 6.98467C16.7793 7.32438 16.4344 8.01025 15.113 8.01025C14.5124 8.01025 14.1313 7.8333 13.9143 7.68863C13.8148 7.62251 13.7244 7.54346 13.6457 7.45355C13.5004 7.24654 13.2798 7.10458 13.0312 7.058C12.7826 7.01142 12.5257 7.06391 12.3153 7.20425C11.5609 7.68863 12.0466 8.54759 12.0466 8.54759L12.0479 8.54888L12.0492 8.55146L12.0518 8.55534L12.0582 8.56567L12.075 8.58892L12.1215 8.65092C12.3275 8.9018 12.5695 9.12075 12.8397 9.30063C13.3486 9.64034 14.0991 9.94775 15.113 9.94775C17.2081 9.94775 18.6393 8.69613 18.7336 7.09834C18.7554 6.73275 18.7009 6.36661 18.5735 6.02325C18.446 5.67989 18.2485 5.36682 17.9934 5.104C18.5243 4.55246 18.7762 3.83042 18.7336 3.10967C18.638 1.51188 17.2081 0.260254 15.113 0.260254C14.0991 0.260254 13.3486 0.56767 12.8397 0.907379C12.5695 1.08726 12.3275 1.30621 12.1215 1.55709C12.1056 1.57743 12.0901 1.59811 12.075 1.61909L12.0582 1.64234L12.0518 1.65267L12.0492 1.65655L12.0479 1.65913L12.0466 1.66042C11.9015 1.87247 11.8466 2.13347 11.894 2.386C11.9413 2.63853 12.0871 2.8619 12.2991 3.00698C12.5112 3.15206 12.7722 3.20696 13.0247 3.1596C13.2772 3.11225 13.5006 2.96651 13.6457 2.75446C13.7244 2.66455 13.8148 2.5855 13.9143 2.51938C14.1326 2.37471 14.5124 2.19775 15.113 2.19775C16.4344 2.19775 16.7793 2.88363 16.7999 3.22334C16.8064 3.32957 16.7887 3.43588 16.7482 3.53431C16.7077 3.63273 16.6455 3.72072 16.5661 3.79167V3.79167ZM13.6586 7.47292L13.6496 7.45871V7.4613L13.6547 7.46646L13.656 7.46905L13.6586 7.47163V7.47292ZM13.6586 2.73638L13.6496 2.7493V2.74671L13.6547 2.74155L13.656 2.73896L13.6586 2.73638V2.73638ZM2.5128 1.42146L2.52185 1.55063V8.65092C2.52436 8.89812 2.43228 9.13692 2.26445 9.31843C2.09663 9.49994 1.86577 9.61043 1.61913 9.62727C1.3725 9.64411 1.12876 9.56603 0.937823 9.40901C0.746887 9.25199 0.623203 9.02791 0.592096 8.78267L0.584347 8.65092V2.89784L-0.0782786 3.1213C-0.300131 3.19556 -0.541366 3.18704 -0.757421 3.09729C-0.973476 3.00754 -1.14976 2.84264 -1.2537 2.63305L-1.30536 2.51034C-1.37963 2.28848 -1.3711 2.04725 -1.28136 1.83119C-1.19161 1.61514 -1.02671 1.43886 -0.817112 1.33492L-0.694404 1.28325L1.24439 0.633546C1.37961 0.588122 1.52319 0.573121 1.66488 0.589615C1.80658 0.606108 1.94287 0.65369 2.06405 0.728959C2.18522 0.804229 2.28827 0.90533 2.36585 1.02504C2.44342 1.14475 2.4936 1.28011 2.5128 1.42146V1.42146ZM19.9916 6.39567H23.5024C23.7593 6.39567 24.0057 6.49773 24.1874 6.67941C24.3691 6.86109 24.4711 7.10749 24.4711 7.36442V19.6417C24.4711 19.8986 24.3691 20.145 24.1874 20.3267C24.0057 20.5084 23.7593 20.6105 23.5024 20.6105H3.48801C3.23108 20.6105 2.98468 20.5084 2.803 20.3267C2.62133 20.145 2.51926 19.8986 2.51926 19.6417V10.6633C2.22113 10.8169 1.89245 10.902 1.55724 10.9122C1.22202 10.9225 0.888749 10.8578 0.581763 10.7228V19.6417C0.581763 20.4125 0.887956 21.1517 1.43298 21.6967C1.97801 22.2418 2.71723 22.548 3.48801 22.548H23.5024C24.2732 22.548 25.0124 22.2418 25.5574 21.6967C26.1024 21.1517 26.4086 20.4125 26.4086 19.6417V7.36442C26.4086 6.59363 26.1024 5.85442 25.5574 5.30939C25.0124 4.76436 24.2732 4.45817 23.5024 4.45817H19.8444C19.7734 4.68111 19.6826 4.89725 19.5731 5.104C19.7888 5.51088 19.9296 5.94746 19.9916 6.39567ZM20.2797 16.729H6.71718L6.58543 16.738C6.34227 16.7715 6.12088 16.896 5.96599 17.0864C5.8111 17.2768 5.73425 17.5189 5.75098 17.7638C5.76771 18.0087 5.87677 18.2381 6.05612 18.4056C6.23547 18.5732 6.47173 18.6664 6.71718 18.6665H20.2797L20.4114 18.6575C20.6546 18.624 20.876 18.4995 21.0309 18.3091C21.1858 18.1187 21.2626 17.8766 21.2459 17.6317C21.2292 17.3868 21.1201 17.1575 20.9407 16.9899C20.7614 16.8223 20.5251 16.7291 20.2797 16.729V16.729ZM20.6026 13.4998C20.6026 13.1573 20.4665 12.8287 20.2243 12.5865C19.982 12.3443 19.6535 12.2082 19.3109 12.2082C18.9684 12.2082 18.6398 12.3443 18.3976 12.5865C18.1554 12.8287 18.0193 13.1573 18.0193 13.4998C18.0193 13.8424 18.1554 14.1709 18.3976 14.4132C18.6398 14.6554 18.9684 14.7915 19.3109 14.7915C19.6535 14.7915 19.982 14.6554 20.2243 14.4132C20.4665 14.1709 20.6026 13.8424 20.6026 13.4998ZM12.8591 13.4998C12.8591 13.1573 12.723 12.8287 12.4807 12.5865C12.2385 12.3443 11.91 12.2082 11.5674 12.2082C11.2248 12.2082 10.8963 12.3443 10.654 12.5865C10.4118 12.8287 10.2757 13.1573 10.2757 13.4998C10.2757 13.8424 10.4118 14.1709 10.654 14.4132C10.8963 14.6554 11.2248 14.7915 11.5674 14.7915C11.91 14.7915 12.2385 14.6554 12.4807 14.4132C12.723 14.1709 12.8591 13.8424 12.8591 13.4998ZM8.98406 13.4998C8.98406 13.1573 8.84797 12.8287 8.60574 12.5865C8.3635 12.3443 8.03496 12.2082 7.69239 12.2082C7.34982 12.2082 7.02128 12.3443 6.77904 12.5865C6.53681 12.8287 6.40072 13.1573 6.40072 13.4998C6.40072 13.8424 6.53681 14.1709 6.77904 14.4132C7.02128 14.6554 7.34982 14.7915 7.69239 14.7915C8.03496 14.7915 8.3635 14.6554 8.60574 14.4132C8.84797 14.1709 8.98406 13.8424 8.98406 13.4998ZM16.7341 13.4998C16.7341 13.1573 16.598 12.8287 16.3557 12.5865C16.1135 12.3443 15.785 12.2082 15.4424 12.2082C15.0998 12.2082 14.7713 12.3443 14.529 12.5865C14.2868 12.8287 14.1507 13.1573 14.1507 13.4998C14.1507 13.8424 14.2868 14.1709 14.529 14.4132C14.7713 14.6554 15.0998 14.7915 15.4424 14.7915C15.785 14.7915 16.1135 14.6554 16.3557 14.4132C16.598 14.1709 16.7341 13.8424 16.7341 13.4998ZM22.5336 9.62484C22.5336 9.28227 22.3976 8.95373 22.1553 8.71149C21.9131 8.46926 21.5845 8.33317 21.242 8.33317C20.8994 8.33317 20.5709 8.46926 20.3286 8.71149C20.0864 8.95373 19.9503 9.28227 19.9503 9.62484C19.9503 9.96741 20.0864 10.2959 20.3286 10.5382C20.5709 10.7804 20.8994 10.9165 21.242 10.9165C21.5845 10.9165 21.9131 10.7804 22.1553 10.5382C22.3976 10.2959 22.5336 9.96741 22.5336 9.62484Z"
                  fill="black"
                />
              </svg>
            </b-col>

            <b-col
              id="numero-rastreio"
              class="info-display"
              :style="estadoCompostoStyle"
              v-b-tooltip.hover
              :title="estado.charAt(0).toUpperCase() + estado.slice(1)"
            >
              {{ compound.compound_number }}
            </b-col>
          </b-row>
        </b-col>

        <b-col>
          <p class="info-title">Tipo de Cogumelo</p>
          <b-row no-gutters>
            <b-col cols="3" class="icon">
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.4974 0.416504C14.0842 0.416504 15.6555 0.729049 17.1215 1.33629C18.5875 1.94354 19.9196 2.83359 21.0416 3.95563C22.1636 5.07767 23.0537 6.40973 23.6609 7.87574C24.2682 9.34176 24.5807 10.913 24.5807 12.4998C24.5807 13.1408 24.3261 13.7555 23.8729 14.2087C23.4197 14.6619 22.805 14.9165 22.1641 14.9165H2.83073C2.18979 14.9165 1.5751 14.6619 1.12189 14.2087C0.668675 13.7555 0.414063 13.1408 0.414062 12.4998C0.414063 9.29514 1.68712 6.22169 3.95319 3.95563C6.21925 1.68957 9.2927 0.416504 12.4974 0.416504ZM12.4974 7.6665C13.1383 7.6665 13.753 7.41189 14.2062 6.95868C14.6594 6.50547 14.9141 5.89078 14.9141 5.24984C14.9141 4.6089 14.6594 3.99421 14.2062 3.541C13.753 3.08778 13.1383 2.83317 12.4974 2.83317C11.8565 2.83317 11.2418 3.08778 10.7886 3.541C10.3353 3.99421 10.0807 4.6089 10.0807 5.24984C10.0807 5.89078 10.3353 6.50547 10.7886 6.95868C11.2418 7.41189 11.8565 7.6665 12.4974 7.6665ZM18.5391 12.4998C19.18 12.4998 19.7947 12.2452 20.2479 11.792C20.7011 11.3388 20.9557 10.7241 20.9557 10.0832C20.9557 9.44223 20.7011 8.82754 20.2479 8.37433C19.7947 7.92112 19.18 7.6665 18.5391 7.6665C17.8981 7.6665 17.2834 7.92112 16.8302 8.37433C16.377 8.82754 16.1224 9.44223 16.1224 10.0832C16.1224 10.7241 16.377 11.3388 16.8302 11.792C17.2834 12.2452 17.8981 12.4998 18.5391 12.4998ZM6.45573 12.4998C7.09667 12.4998 7.71136 12.2452 8.16457 11.792C8.61778 11.3388 8.8724 10.7241 8.8724 10.0832C8.8724 9.44223 8.61778 8.82754 8.16457 8.37433C7.71136 7.92112 7.09667 7.6665 6.45573 7.6665C5.81479 7.6665 5.2001 7.92112 4.74689 8.37433C4.29367 8.82754 4.03906 9.44223 4.03906 10.0832C4.03906 10.7241 4.29367 11.3388 4.74689 11.792C5.2001 12.2452 5.81479 12.4998 6.45573 12.4998ZM16.1224 16.1248L17.657 21.5019L17.7536 22.1665C17.7536 23.4957 16.6661 24.5832 15.337 24.5832H9.65781C9.01687 24.5832 8.40218 24.3286 7.94897 23.8753C7.49576 23.4221 7.24115 22.8074 7.24115 22.1665L7.33781 21.5019L8.8724 16.1248H16.1224Z"
                  fill="black"
                />
              </svg>
            </b-col>

            <b-col class="info-display">
              {{ compound.product.type }}
            </b-col>
          </b-row>
        </b-col>

        <b-col>
          <p class="info-title">Data de Chegada</p>
          <b-row no-gutters>
            <b-col cols="3" class="icon">
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.6875 0C5.90299 0 6.10965 0.0856024 6.26202 0.237976C6.4144 0.390349 6.5 0.597012 6.5 0.8125V1.625H19.5V0.8125C19.5 0.597012 19.5856 0.390349 19.738 0.237976C19.8903 0.0856024 20.097 0 20.3125 0C20.528 0 20.7347 0.0856024 20.887 0.237976C21.0394 0.390349 21.125 0.597012 21.125 0.8125V1.625H22.75C23.612 1.625 24.4386 1.96741 25.0481 2.5769C25.6576 3.1864 26 4.01305 26 4.875V22.75C26 23.612 25.6576 24.4386 25.0481 25.0481C24.4386 25.6576 23.612 26 22.75 26H3.25C2.38805 26 1.5614 25.6576 0.951903 25.0481C0.34241 24.4386 0 23.612 0 22.75V4.875C0 4.01305 0.34241 3.1864 0.951903 2.5769C1.5614 1.96741 2.38805 1.625 3.25 1.625H4.875V0.8125C4.875 0.597012 4.9606 0.390349 5.11298 0.237976C5.26535 0.0856024 5.47201 0 5.6875 0V0ZM1.625 6.5V22.75C1.625 23.181 1.7962 23.5943 2.10095 23.899C2.4057 24.2038 2.81902 24.375 3.25 24.375H22.75C23.181 24.375 23.5943 24.2038 23.899 23.899C24.2038 23.5943 24.375 23.181 24.375 22.75V6.5H1.625Z"
                  fill="black"
                />
              </svg>
            </b-col>

            <b-col class="info-display">
              {{ convertDate(compound.arrived_date) }}
            </b-col>
          </b-row>
        </b-col>

        <b-col>
          <p class="info-title">Qtd Produzida</p>
          <b-row no-gutters>
            <b-col cols="3" class="icon">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.7863 3.17476C14.1576 2.96856 14.5753 2.86035 15 2.86035C15.4247 2.86035 15.8424 2.96856 16.2137 3.17476L25.6075 8.39226C25.8023 8.50056 25.9645 8.65896 26.0775 8.85104C26.1904 9.04313 26.25 9.26192 26.25 9.48476V19.7785C26.2499 20.2243 26.1306 20.662 25.9044 21.0462C25.6783 21.4304 25.3535 21.7471 24.9638 21.9635L16.2137 26.826C15.8424 27.0322 15.4247 27.1404 15 27.1404C14.5753 27.1404 14.1576 27.0322 13.7863 26.826L5.03625 21.9635C4.64669 21.7472 4.32204 21.4307 4.09589 21.0467C3.86975 20.6628 3.75033 20.2254 3.75 19.7798V9.48476C3.74999 9.26192 3.80955 9.04313 3.92252 8.85104C4.03548 8.65896 4.19775 8.50056 4.3925 8.39226L13.7875 3.17476H13.7863Z"
                  stroke="black"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3.75 8.75L15 15M15 15L26.25 8.75M15 15V27.5"
                  stroke="black"
                  stroke-width="2.5"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.375 11.875L20.625 5.625M7.5 15.41L11.25 17.5"
                  stroke="black"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </b-col>

            <b-col class="info-display">
              {{ compound.quantity_produced.toFixed(2) }}
            </b-col>
          </b-row>
        </b-col>

        <b-col>
          <p class="info-title">Peso Inicial</p>
          <b-row no-gutters>
            <b-col cols="3" class="icon">
              <svg
                width="28"
                height="26"
                viewBox="0 0 28 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5484 0.0742188C10.8221 0.0742188 8.58871 2.30765 8.58871 5.0339C8.58871 6.59511 9.32196 7.99373 10.46 8.90486H5.80645L0 26.3242H27.0968L21.2903 8.90486H16.6368C17.7748 7.99373 18.5081 6.59511 18.5081 5.0339C18.5081 2.30765 16.2746 0.0742188 13.5484 0.0742188ZM13.5484 2.25164C15.0979 2.25164 16.3306 3.48442 16.3306 5.0339C16.3306 6.58337 15.0979 7.81615 13.5484 7.81615C11.9989 7.81615 10.7661 6.58337 10.7661 5.0339C10.7661 3.48442 11.9989 2.25164 13.5484 2.25164ZM8.57571 14.5268H9.99708V16.5387L12.0458 14.5268H13.696L11.0418 17.1367L13.9692 20.0383H12.1899L9.99708 17.8677V20.0383H8.57571V14.5268ZM15.8298 15.8115C16.1177 15.8115 16.3712 15.868 16.5902 15.9812C16.8092 16.0945 17.0099 16.2728 17.1921 16.5165V15.9038H18.521V19.6213C18.521 20.2858 18.3105 20.7927 17.8897 21.1422C17.4713 21.4942 16.8634 21.67 16.066 21.67C15.8076 21.67 15.5579 21.6504 15.3166 21.611C15.0697 21.5703 14.8265 21.5098 14.5893 21.4302V20.4001C14.8207 20.5331 15.0472 20.6315 15.2685 20.6955C15.4902 20.7619 15.7129 20.7952 15.9369 20.7952C16.3701 20.7952 16.6875 20.7005 16.8893 20.5109C17.0911 20.3215 17.1921 20.0249 17.1921 19.6213V19.3371C17.01 19.5781 16.8093 19.7554 16.5902 19.8686C16.3713 19.9817 16.1177 20.0384 15.8298 20.0384C15.3252 20.0384 14.9081 19.8403 14.5784 19.4441C14.2485 19.0454 14.0836 18.5384 14.0836 17.9232C14.0836 17.3054 14.2485 16.7996 14.5784 16.4059C14.9081 16.0097 15.3252 15.8115 15.8298 15.8115ZM16.3208 16.7639C16.0476 16.7639 15.8346 16.8649 15.6821 17.0666C15.5295 17.2685 15.4532 17.554 15.4532 17.9232C15.4532 18.3022 15.527 18.5901 15.6747 18.7869C15.8224 18.9814 16.0378 19.0786 16.3208 19.0786C16.5964 19.0786 16.8105 18.9776 16.9631 18.7758C17.1157 18.574 17.192 18.2898 17.192 17.9231C17.192 17.5539 17.1157 17.2685 16.9631 17.0667C16.8105 16.8648 16.5964 16.7639 16.3207 16.7639H16.3208Z"
                  fill="black"
                />
              </svg>
            </b-col>

            <b-col class="info-display">
              {{ compound.quantity_arrived }}
            </b-col>
          </b-row>
        </b-col>

        <b-col>
          <p class="info-title">Nota fiscal</p>

          <b-row no-gutters>
            <b-col cols="3" class="icon">
              <svg
                width="22"
                height="29"
                viewBox="0 0 22 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.75 25.375V8.15625L13.5938 0H3.625C2.66359 0 1.74156 0.381919 1.06174 1.06174C0.381918 1.74156 0 2.66359 0 3.625V25.375C0 26.3364 0.381918 27.2584 1.06174 27.9383C1.74156 28.6181 2.66359 29 3.625 29H18.125C19.0864 29 20.0084 28.6181 20.6883 27.9383C21.3681 27.2584 21.75 26.3364 21.75 25.375ZM13.5938 5.4375C13.5938 6.15856 13.8802 6.85008 14.3901 7.35995C14.8999 7.86981 15.5914 8.15625 16.3125 8.15625H19.9375V25.375C19.9375 25.8557 19.7465 26.3167 19.4066 26.6566C19.0667 26.9965 18.6057 27.1875 18.125 27.1875H3.625C3.14429 27.1875 2.68328 26.9965 2.34337 26.6566C2.00346 26.3167 1.8125 25.8557 1.8125 25.375V3.625C1.8125 3.14429 2.00346 2.68328 2.34337 2.34337C2.68328 2.00346 3.14429 1.8125 3.625 1.8125H13.5938V5.4375Z"
                  fill="black"
                />
                <path
                  d="M4.71626 25.5331C4.36299 25.3918 4.07837 25.1189 3.92239 24.7719C3.56895 24.0686 3.68676 23.3654 4.06739 22.7745C4.42626 22.2181 5.02076 21.745 5.6932 21.3481C6.54496 20.865 7.44532 20.4731 8.37933 20.179C9.10467 18.8751 9.74756 17.5269 10.3042 16.1426C9.97139 15.3863 9.71045 14.6005 9.52483 13.7954C9.36895 13.0704 9.30914 12.3526 9.44145 11.7364C9.57739 11.0947 9.93808 10.5184 10.6196 10.2447C10.9676 10.1051 11.3446 10.0272 11.7107 10.1051C11.8949 10.1443 12.068 10.224 12.2175 10.3385C12.3671 10.4529 12.4893 10.5992 12.5753 10.7667C12.7348 11.0639 12.7928 11.4119 12.8055 11.7418C12.8181 12.0826 12.7837 12.4596 12.7203 12.8547C12.568 13.7791 12.2309 14.9101 11.7778 16.1063C12.2778 17.1757 12.8723 18.1984 13.554 19.1622C14.3608 19.0985 15.1722 19.1289 15.9719 19.2528C16.6316 19.3724 17.3023 19.6062 17.7119 20.0956C17.9294 20.3566 18.0617 20.6756 18.0744 21.0345C18.0871 21.3825 17.9892 21.7269 17.8243 22.0549C17.6814 22.3589 17.4599 22.6193 17.1826 22.8089C16.9086 22.9877 16.5851 23.0752 16.2583 23.0591C15.6583 23.0337 15.0729 22.7038 14.5672 22.3032C13.9523 21.7948 13.3982 21.217 12.916 20.5814C11.6903 20.7205 10.4792 20.9667 9.29645 21.3172C8.75484 22.2778 8.13658 23.193 7.4477 24.0541C6.91845 24.6885 6.34389 25.2431 5.76751 25.4806C5.43635 25.6304 5.06072 25.6491 4.71626 25.5331ZM7.2157 22.0876C6.91483 22.2253 6.6357 22.3703 6.38376 22.5189C5.78926 22.8706 5.4032 23.2131 5.21108 23.5104C5.0407 23.7732 5.03708 23.9635 5.13858 24.1647C5.1567 24.2046 5.17483 24.2299 5.1857 24.2444C5.20733 24.2387 5.22852 24.2314 5.24914 24.2227C5.49745 24.1212 5.89258 23.7967 6.40008 23.1859C6.68871 22.8325 6.96087 22.466 7.2157 22.0876ZM10.1882 19.6769C10.7934 19.5357 11.4041 19.419 12.0188 19.3271C11.6888 18.8221 11.3804 18.3032 11.0945 17.772C10.8102 18.4147 10.508 19.0493 10.1882 19.6751V19.6769ZM14.6216 20.4926C14.8935 20.788 15.1581 21.0363 15.41 21.2357C15.845 21.5801 16.1477 21.6942 16.3126 21.6997C16.3568 21.7055 16.4016 21.6959 16.4395 21.6725C16.5149 21.6129 16.5736 21.5349 16.6099 21.4459C16.6743 21.3355 16.711 21.2111 16.7168 21.0834C16.7158 21.0408 16.699 21.0002 16.6697 20.9692C16.5755 20.8569 16.3072 20.6937 15.7308 20.5904C15.3642 20.5291 14.9933 20.497 14.6216 20.4944V20.4926ZM11.0147 14.1379C11.1672 13.6459 11.2883 13.1446 11.3772 12.6372C11.4334 12.2964 11.4551 12.0155 11.4461 11.7944C11.4466 11.6724 11.427 11.5511 11.3881 11.4355C11.2974 11.4467 11.2089 11.4711 11.1253 11.508C10.9676 11.5714 10.8389 11.7001 10.77 12.0209C10.6975 12.3689 10.7156 12.871 10.8534 13.5108C10.8969 13.712 10.9513 13.9222 11.0165 14.1379H11.0147Z"
                  fill="black"
                />
              </svg>
            </b-col>

            <b-col
              class="info-display"
              v-on:click="getFile"
              style="cursor: pointer"
            >
              Documento
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="0.5">
          <p class="info-title">Produção</p>

          <b-row no-gutters>
            <b-col class="info-display"> {{ getPercentual() + '%' }} </b-col>
          </b-row>
        </b-col>

        <b-col>
          <b-row style="color: #e5e5e5"> - </b-row>

          <b-row
            class="btn-maisdetalhes info-display"
            align-h="between"
            no-gutters
            @click="maisDetalhes = !maisDetalhes"
          >
            <b-col cols="1"><i class="arrow"></i> </b-col>
            <b-col cols="10" class="jus">
              {{ maisDetalhes ? 'menos' : 'mais' }} detalhes</b-col
            >
          </b-row>
        </b-col>
      </b-row>
    </div>

    <b-row
      no-gutters
      class="details pb-3 pt-3"
      :class="{ active: maisDetalhes }"
    >
      <!-- <HistoryTable :houses="compound.housesHistory" ></HistoryTable> -->

      <b-col cols="12" class="mb-1">
        <textarea
          :disabled="!editing"
          class="observation-textarea"
          v-model="description"
          @click="editing = true"
        ></textarea>
      </b-col>

      <b-col cols="1" class="mb-1">
        <button id="btn-editar" @click="goToEditView()">
          <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5579 4.09136L8.98916 1.3776L10.0171 0.292101C10.4748 -0.191538 11.523 -0.287498 12.0715 0.292101L12.5851 0.834852C13.1336 1.41445 13.0435 2.52222 12.5851 3.00662L11.5579 4.09136ZM10.5307 5.17763L3.33879 12.7777L0 13.5914L0.770043 10.0632L7.96195 2.46311L10.5307 5.17763Z"
              fill="#D65600"
            />
          </svg>

          Editar
        </button>
      </b-col>

      <b-col cols="sm-3 md-5">
        <button
          id="btn-excluir"
          @click="$emit('exclusao', compound.id, compound.is_discarded)"
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.125 5.3125L3.11246 14.6927C3.13306 14.8886 3.22544 15.0698 3.37179 15.2016C3.51814 15.3334 3.7081 15.4063 3.90502 15.4062H13.095C13.2919 15.4063 13.4819 15.3334 13.6282 15.2016C13.7746 15.0698 13.8669 14.8886 13.8875 14.6927L14.875 5.3125H2.125ZM10.3594 12.5329L8.5 10.6735L6.64062 12.5329L5.79527 11.6875L7.65465 9.82812L5.79527 7.96875L6.64062 7.1234L8.5 8.98277L10.3594 7.1234L11.2047 7.96875L9.34535 9.82812L11.2047 11.6875L10.3594 12.5329Z"
              fill="#D12C38"
            />
            <path
              d="M15.5391 1.59375H1.46094C1.24089 1.59375 1.0625 1.77214 1.0625 1.99219V3.85156C1.0625 4.07161 1.24089 4.25 1.46094 4.25H15.5391C15.7591 4.25 15.9375 4.07161 15.9375 3.85156V1.99219C15.9375 1.77214 15.7591 1.59375 15.5391 1.59375Z"
              fill="#D12C38"
            />
          </svg>

          <div class="pl-2" style="display: inline">Descartar Composto</div>
        </button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import MixinConvertDate from '../../utils/MixinConvertDate';
import showError from '../../utils/showError';
// import HistoryTable from './HistoryTable.vue';

export default {
  props: ['compound'],

  mixins: [MixinConvertDate],

  data() {
    return {
      maisDetalhes: false,
      description: this.compound.more_details,
      editing: false,
      showRow: true,
      percentual: 0, // sera obtido atraves de um calculo de porcentagem da producao
      estado: '',
    };
  },
  methods: {
    getFile() {
      const invoiceName = this.compound.invoice;
      if (invoiceName == null) {
        showError('Não há Nota Fiscal cadastrada neste composto.');
      } else {
        const fileName = `${invoiceName}`;
        window.open(fileName, '_blank');
      }
    },
    getPercentual() {
      this.percentual = (
        (parseFloat(this.compound.quantity_produced) /
          parseFloat(this.compound.quantity_arrived)) *
        100
      ).toFixed(2);
      return this.percentual;
    },

    goToEditView() {
      this.$router.push(`/composto/${this.compound.id}`);
    },

    calcularEstadoCompostoStyle() {
      if (this.compound.is_discarded) {
        this.estado = 'Descartado';
        return { color: '#000', textDecoration: 'line-through' };
      }
      if (this.percentual < 10) {
        this.estado = 'Produção baixa';
        return { color: '#D12C38' };
      }
      if (this.percentual < 15) {
        this.estado = 'Produção média';
        return { color: '#BB8A0B' };
      }
      this.estado = 'Produção alta';
      return { color: '#19875D' };
    },
  },

  computed: {
    estadoCompostoStyle() {
      return this.calcularEstadoCompostoStyle();
    },
  },
};
</script>
<style scoped>
/* ------- estilização do card principal de cada composto--------- */

.container {
  overflow: hidden !important;
  max-width: 1340px;
}

.info-title {
  font-size: 0.91em;
  display: inline;
  color: #555;
}

.info-display {
  border: 1px solid #aaa;
  border-radius: 0.5em;

  padding-left: 0.5em;

  font-weight: bolder;
  overflow-x: scroll;
  height: 26px;
}

.compound-info {
  width: 1260px;
}

.compound-wrapper {
  width: 100%;
  overflow-x: scroll;
  position: relative;
  z-index: 10;
  background: #e5e5e5;
  padding-bottom: 1em;
}

/* ------- Botão mais/menos detalhes  --------- */

.arrow {
  border: solid black;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  margin-right: 3px;
  margin-bottom: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.btn-maisdetalhes {
  font-size: 0.9rem;
  text-align: center;
  max-width: 150px;
}

.btn-maisdetalhes:hover {
  cursor: pointer;
}

/* ------- Detalhes do Composto  --------- */

.details {
  transition: 1s;
  position: relative;
  z-index: 5;
  overflow-y: scroll;
  height: 10em;
  margin-bottom: -10em;
  bottom: 10em;
}

.active {
  margin-bottom: 0;
  bottom: 0;
}

/* ------- scrollbars nos detalhes, nos displays e na descrição--------- */

.info-display::-webkit-scrollbar,
.observation-textarea::-webkit-scrollbar {
  display: none;
}

.details::-webkit-scrollbar {
  width: 4px;
}

.details::-webkit-scrollbar-thumb {
  border-radius: 20px;
  border: 5px solid;
}

.compound-wrapper::-webkit-scrollbar {
  height: 7px;
  border-radius: 20px;
}

.compound-wrapper::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: transparent;
}

.compound-wrapper:hover::-webkit-scrollbar-thumb {
  background: #be8250;
}

.compound-wrapper:hover::-webkit-scrollbar {
  background: #aaa;
}

.compound-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a2591d;
}

/* ------- botões de edição e exclusão  nos detalhes do composto--------- */

#btn-editar,
#btn-excluir,
#btn-concluido {
  border: none;
  padding: 0.2em 0.5em;
  border-radius: 10px;
}

#btn-editar:focus,
#btn-excluir:focus,
#btn-concluido {
  border: none;
  outline: none;
}

#btn-editar {
  color: #d65600;
  background-color: hsla(27, 46%, 53%, 0.16);
}

#btn-excluir {
  display: flex;
  align-items: center;
  color: #b40505;
  background: hsl(0, 71%, 47%, 16%);
}

#btn-concluido {
  color: #0f7c0c;
  text-decoration: underline;
  background-color: rgba(77, 174, 137, 0.32);
}

/* ------- textarea da descrição nos detalhes--------- */

.observation-textarea {
  background-color: transparent;
  border-radius: 10px;
  width: 90%;
  padding: 0.4em 0.6em;
  height: fit-content;
  box-shadow: 2px 3px 3px 1px rgba(0, 0, 0, 0.2);
}
</style>
